import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-secondary-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-lg text-white"></i>
              </div>
              <span className="font-heading font-bold text-xl text-white">基德漫画</span>
            </div>
            <p className="text-sm leading-relaxed text-secondary-400">
              基德漫画网提供好看韩漫漫画免费漫画，支持韩漫免费漫画在线观看下拉式，阅读更便捷。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">快速链接</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-secondary-400 hover:text-white whitespace-nowrap cursor-pointer transition-colors duration-200">首页</Link>
              <Link to="/category/all" className="text-sm text-secondary-400 hover:text-white whitespace-nowrap cursor-pointer transition-colors duration-200">全部漫画</Link>
              <Link to="/category/romance" className="text-sm text-secondary-400 hover:text-white whitespace-nowrap cursor-pointer transition-colors duration-200">恋爱漫画</Link>
              <Link to="/category/fantasy" className="text-sm text-secondary-400 hover:text-white whitespace-nowrap cursor-pointer transition-colors duration-200">奇幻漫画</Link>
              <Link to="/category/action" className="text-sm text-secondary-400 hover:text-white whitespace-nowrap cursor-pointer transition-colors duration-200">热血漫画</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">热门分类</h4>
            <div className="flex flex-col gap-2.5">
              {categories.filter(c => c.slug !== 'all').slice(0, 5).map(cat => (
                <Link key={cat.slug} to={`/category/${cat.slug}`} className="text-sm text-secondary-400 hover:text-white whitespace-nowrap cursor-pointer transition-colors duration-200">
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">关于我们</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/about" className="text-sm text-secondary-400 hover:text-white whitespace-nowrap cursor-pointer transition-colors duration-200">品牌介绍</Link>
              <span className="text-sm text-secondary-500">contact@jidemanhua.com</span>
              <span className="text-sm text-secondary-500">广东省深圳市南山区</span>
            </div>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-white cursor-pointer transition-colors duration-200" aria-label="Weibo" rel="nofollow">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-white cursor-pointer transition-colors duration-200" aria-label="WeChat" rel="nofollow">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-white cursor-pointer transition-colors duration-200" aria-label="QQ" rel="nofollow">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-800">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-500">
            &copy; 2024 基德漫画网 - 好看韩漫免费漫画在线观看
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-secondary-500 hover:text-secondary-300 whitespace-nowrap cursor-pointer transition-colors duration-200">用户协议</a>
            <a href="#" className="text-xs text-secondary-500 hover:text-secondary-300 whitespace-nowrap cursor-pointer transition-colors duration-200">隐私政策</a>
            <a href="#" className="text-xs text-secondary-500 hover:text-secondary-300 whitespace-nowrap cursor-pointer transition-colors duration-200">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}